var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-check-list" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-info" }, [
        _c("div", { staticClass: "header-title" }, [_vm._v("待质检列表")]),
        _c("div", { staticClass: "header-count" }, [
          _vm._v("当前共检测到" + _vm._s(_vm.list.length) + "台设备")
        ])
      ]),
      _c(
        "div",
        {
          staticClass: "header-refresh-btn",
          on: { click: _vm.onclickRefreshBtn }
        },
        [_vm._v("刷 新")]
      )
    ]),
    _c(
      "div",
      { staticClass: "list" },
      _vm._l(_vm.list, function(item, index) {
        return _c(
          "div",
          { key: index, staticClass: "item" },
          [
            _c("div", { staticClass: "item-left" }, [
              _c("img", {
                staticClass: "icon-feeder",
                attrs: { src: _vm.ossPondHost + "img/xiazeng_icon.png" }
              }),
              _c("div", { staticClass: "item-num" }, [
                _vm._v(_vm._s(item.displayNum))
              ]),
              item.passed
                ? _c("i", {
                    staticClass: "item-checked van-icon van-icon-checked"
                  })
                : _vm._e()
            ]),
            item.qcDone
              ? _c("div", { staticClass: "item-done" }, [_vm._v("已出厂")])
              : [
                  _c(
                    "div",
                    {
                      staticClass: "item-btn",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.onclickLightBtn(index)
                        }
                      }
                    },
                    [_vm._v("亮灯")]
                  ),
                  item.passed
                    ? _c(
                        "div",
                        {
                          staticClass: "item-btn",
                          on: {
                            click: function($event) {
                              return _vm.onclickGoQaBtn(index)
                            }
                          }
                        },
                        [_vm._v("查看")]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "item-btn",
                          on: {
                            click: function($event) {
                              return _vm.onclickGoQaBtn(index)
                            }
                          }
                        },
                        [_vm._v("去质检")]
                      )
                ]
          ],
          2
        )
      }),
      0
    ),
    !_vm.list.length
      ? _c("div", { staticClass: "list-tip" }, [
          _vm._v("暂无待质检设备，请将设备通电")
        ])
      : _vm._e(),
    _c("div", { staticClass: "footer" }, [
      _c(
        "div",
        {
          class: ["btn-submit", { disabled: !_vm.canSubmitCount }],
          on: { click: _vm.onclickSubmitBtn }
        },
        [
          _vm._v(
            " 提交质检(" +
              _vm._s(_vm.canSubmitCount) +
              "/" +
              _vm._s(_vm.unfinishedCount) +
              ") "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }